import request from "~/utils/http";

const productCategoryApi =
{
    get : async (id) =>
    {
        const url = `product-category/detail/${id}`;
        return await request.get(url);
    },
    gets : async (params) =>
    {
        const url = 'product-category';
        return await request.get(url, {params});
    },
    options : async () =>
    {
        const url = 'product-category/options';
        return await request.get(url);
    },
    add : async (params) =>
    {
        const url = 'product-category';
        return await request.post(url, params);
    },
    update : async (params) =>
    {
        const url = `product-category/${params.id}`;
        return await request.post(url, params);
    },
    delete : async (id) =>
    {
        const url = `product-category/delete/${id}`;
        return await request.delete(url);
    },
};

export default productCategoryApi;
